import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import './assets/css/tailwind.output.css'
import App from './App'
import { SidebarProvider } from './context/SidebarContext'
import ThemedSuspense from './components/ThemedSuspense'
import { Windmill } from '@windmill/react-ui'
import register from './serviceWorker'
import defaultTheme from './defaultTheme'
import ErrorBoundary from './components/ErrorBoundary'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as Sentry from "@sentry/react";

// import './index.scss'

// if (process.env.NODE_ENV !== 'production') {
//   const axe = require('react-axe')
//   axe(React, ReactDOM, 1000)
// }

// Добавляем обработчик глобальных ошибок
window.onerror = function(msg, url, lineNo, columnNo, error) {
  console.error('Global error:', { msg, url, lineNo, columnNo, error });
  return false;
};

// Добавляем обработчик необработанных промисов
window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
});

// Sentry.init({
//   dsn: "https://80dbdf46992f30c04ccf541c55010600@sentry.vertical-tech.ru/8",
//   integrations: [
//     Sentry.browserTracingIntegration()
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/api-gateway\.dev\.dooooom\.ru\/api/]
// });


const retryLoadComponent = (importFn: () => Promise<any>, retries = 3) => {
  return new Promise((resolve, reject) => {
    importFn()
      .then(resolve)
      .catch((error) => {
        if (retries === 0) {
          reject(error);
          return;
        }
        setTimeout(() => {
          retryLoadComponent(importFn, retries - 1).then(resolve, reject);
        }, 1000);
      });
  });
};

ReactDOM.render(
  <ErrorBoundary>
    <SidebarProvider>
      <Suspense fallback={<ThemedSuspense />}>
        {/* <Windmill usePreferences theme={defaultTheme} dark={false}> */}
        <Windmill theme={defaultTheme} dark={false}>
          <App />
        </Windmill>
      </Suspense>
    </SidebarProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
register();